<template>
    <div>
        <el-tree
            v-if="popover === false"
            highlight-current
            draggable
            node-key="id"
            :current-node-key="selectNodeId"
            :default-expanded-keys="idExpandedArr"
            :expand-on-click-node="false"
            :data="treeData"
            :props="defaultProps"
            @node-click="handleTreeNode"
        />

        <el-popover
            v-if="popover === true"
            placement="bottom"
            width="200"
            trigger="focus"
            @after-enter='treeShow'>
            <el-tree
                highlight-current
                v-if="!isRead"
                node-key="id"
                ref="tree"
                :show-checkbox='multiple'
                :current-node-key="selectNodeId"
                :default-expanded-keys="idExpandedArr"
                :expand-on-click-node="false"
                :data="treeData"
                :props="defaultProps"
                @node-click="handleTreeNode"
            />
            <el-input slot="reference" readonly v-model="popoverTreeLable"></el-input>
            <div v-if="multiple  && !isRead"  class="buttons">
              <el-button style="float:right;margin-top:10%" type="primary" @click="getCheckedKeys">确定</el-button>
            </div>
        </el-popover>
    </div>
</template>

<script>
    import { getPositionTreeList } from '@/data-model';
    export default {
        name: 'Position',
        data () {
            return {
                idExpandedArr: [],
                treeData: [],
                selectNodeId: 0,
                popoverTreeLable: ''
            };
        },
        props: {
            rootId: { // 获取节点树结构数据时的根节点id
                type: [ Number, String ]
            },
            data: { // 外部传入的树的结构数据，如果没有传，使用组件自己的接口获取数据
                type: Array
            },
            selectedNode: { // 默认选中的树节点对象
                type: Object
            },
            defaultProps: { // 默认字段名配置
                type: Object
            },
            multiple: { // 是否多选
                type: Boolean,
                default: false
            },
            isRead: {
                type: Boolean,
                default: false
            },
            popover: { // 是否为弹出树
                type: Boolean,
                default: false
            }
        },
        created () {
            this._initPage().then(val => {
                // 初始化默认展开到第二级
                if (this.treeData && this.treeData.length > 0) {
                    this.idExpandedArr = [];
                    this.idExpandedArr.push(this.treeData[0].id);
                }
            });
        },
        methods: {
            async _initPage () {
                await this._getTreeData();
                this._setSelectedNode();
            },
            async _getTreeData () {
                let departmentTreeList = [];
                if (this.data) {
                    departmentTreeList = this.data;
                } else {
                    departmentTreeList = await getPositionTreeList(this.rootId);
                }
                this.treeData = departmentTreeList;
            },
            _setSelectedNode () {
                if (this.selectedNode) {
                    this.popoverTreeLable = this.selectedNode.label;
                    this.selectNodeId = this.selectedNode.id;
                }
            },
            _refreshSelectedNode (node) {
                if (node) {
                    this.popoverTreeLable = node.title;
                    this.selectNodeId = node.value;
                }
            },
            _refreshTreeData (newData) {
                if (newData) {
                    this.treeData = newData;
                }
            },
            handleTreeNode (data, node, tree) {
                if (!this.isRead) {
                    this.popoverTreeLable = data.label;
                    this.$emit('nodeClick', data, node, tree);
                }
            },
            setTreeStatus () {
                this.$refs.tree.setCurrentNode(2);
            },
            treeShow () {
                // console.log('treeShow');
                // this.setTreeStatus();
                this.$emit('treeShow');
            },
            getCheckedKeys () {
                // 采用直接获取节点方法来减少递归消耗
                let checkedNodes = this.$refs.tree.getCheckedNodes();
                let halfCheckedNodes = this.$refs.tree.getHalfCheckedNodes();
                if (this.isContainSelectHalfNode && checkedNodes.length > 0 && halfCheckedNodes.length > 0) {
                    checkedNodes = halfCheckedNodes.concat(checkedNodes);
                }
                let checkedIds = [];
                let checkedNames = [];
                if (checkedNodes.length > 0) {
                    checkedNodes.forEach(item => {
                        checkedIds.push(item.id);
                        checkedNames.push(item.label);
                    });
                }
                let node = {id: '', label: '', selectedIds: '', selectedNames: ''};
                if (checkedIds) {
                    this.popoverTreeLable = checkedNames.join(',');
                    this.selectedContent = this.popoverTreeLable;
                    node.id = checkedIds.join(',');
                    node.selectedIds = checkedIds.join(',');
                    node.label = this.popoverTreeLable;
                    node.selectedNames = this.popoverTreeLable;
                }
                this.$emit('nodeClick', node);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/Position/Position.vue